import { useI18n, useT } from '@kovix/shell-kit/i18n';
import { shellText } from './shellText';

/** Gốc Customer & CTV Portal — build-time (Vite). Bỏ trống = chưa triển khai Portal → không hiện nút. */
const PORTAL_URL = (import.meta.env.VITE_KOVIX_PORTAL_URL ?? '').trim();

/**
 * Nút "Customer & CTV Portal ↗" (mockup v151/v152 `.kx-portal-launch`, Y2 23/09/2026).
 *
 * v151 tách kênh: Admin nội bộ và Portal khách/CTV là **hai frontend độc lập dùng chung backend**. Admin không nhúng trải nghiệm
 * khách hàng; nút này chỉ mở Portal ở tab khác (`noopener`) để nhân sự đối chiếu. Phiên Portal là KOVIX ID của khách,
 * KHÔNG phải phiên nhân sự đang đăng nhập — không truyền token, không deep-link theo tenant.
 * Màn hẹp (≤ 1160 px) chỉ còn "↗" — nhãn đầy đủ nằm ở `aria-label`.
 */
export function PortalLaunch() {
  const t = useT();
  const locale = useI18n((s) => s.locale);
  if (!PORTAL_URL) return null;
  const label = shellText('portal', locale);
  return (
    <a
      className="kx-btn kx-btn-ghost kx-btn-sm kx-portal-launch kx-shell-portal"
      href={PORTAL_URL}
      target="_blank"
      rel="noopener noreferrer"
      title={t('shell.portalLaunchHint')}
      aria-label={`${label} — ${t('shell.portalLaunchHint')}`}
    >
      <span className="kx-shell-portal-text">{label}</span> <span aria-hidden="true">↗</span>
    </a>
  );
}
